<template>
    <transition name="fade">
        <div class="popup fixed-100">
            <div class="content">
                <p class="money">{{ m }}元</p>
                <h3>顺丰优惠券</h3>
                <div class="line-box">
                    <i class="left"></i>
                    <i class="line"></i>
                    <i class="right"></i>
                </div>
                <div class="couponNo">
                    <p>请把<span class="red">优惠券码</span>展示给快递员扫描</p>
                    <div class="i-code">
                        <img id="barcode1" alt="优惠券码" />
                    </div>
                    <p class="num">{{ coupnoNo }}</p>
                </div>
                <div class="couponCode">
                    <p>请把<span class="red">验证码</span>展示给快递员扫描</p>
                    <div class="i-code">
                        <img id="barcode2" alt="验证码" />
                    </div>
                    <p class="num">{{ checkCode }}</p>
                </div>
                <div class="btn" @click="confirm">我知道了</div>
            </div>
        </div>
    </transition>
</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
    props: ['coupno', 'check', 'm'],
    data() {
        return {
            money: this.m,
            coupnoNo: this.coupno,
            checkCode: this.check
        }
    },
    mounted() {
        JsBarcode('#barcode1', this.coupno, {
            displayValue: false
        })
        JsBarcode('#barcode2', this.check, {
            displayValue: false
        })
    },
    methods: {
        confirm() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.popup {
    z-index: 90909;
    background-color: rgba(0, 0, 0, 0.4);
    .content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: scale(1, 1) translate(-50%, -50%);
        background-color: #fff;
        width: 6.53rem;
        padding: 0.3rem 0.3rem 1.72rem 0.3rem;
        font-size: 0.26rem;
        text-align: center;
        .btn {
            width: 5.92rem;
            height: 0.92rem;
            background-color: #dc1e32;
            font-size: 34px;
            color: #fff;
            text-align: center;
            line-height: 0.92rem;
            position: fixed;
            bottom: 0.3rem;
            left: 0.3rem;
        }
        .money {
            color: #dc1e32;
            font-size: 0.7rem;
        }
        h3 {
            font-size: 0.3rem;
        }
        .line-box {
            height: 0.4rem;
            box-sizing: border-box;
            padding-top: 0.18rem;
            position: relative;
            margin-top: 0.2rem;
            i {
                display: block;
            }
            .line {
                height: 0.02rem;
                background-color: #e6e6e6;
            }
            .left {
                width: 0.4rem;
                height: 0.4rem;
                background-color: #999;
                border-radius: 50%;
                position: absolute;
                top: 0;
                left: -0.5rem;
            }
            .right {
                width: 0.4rem;
                height: 0.4rem;
                background-color: #999;
                border-radius: 50%;
                position: absolute;
                top: 0;
                right: -0.5rem;
            }
        }
        .couponNo {
            margin-top: 0.4rem;
            div {
                width: 5.31rem;
                height: 1.89rem;
                margin: 0 auto;
                img {
                    width: 5.3rem;
                    height: 1.65rem;
                }
            }
        }
        .couponCode {
            margin-top: 0.6rem;
            div {
                width: 3.92rem;
                height: 1.89rem;
                margin: 0 auto;
                img {
                    width: 3.9rem;
                    height: 1.65rem;
                }
            }
        }
        .num {
            margin-top: -0.14rem;
            font-size: 0.32rem;
            letter-spacing: 0.1rem;
            margin-right: -0.05rem;
        }
    }
    .content span.red {
        color: #dc1e32;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: 0.3s ease-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupons/components/detail.vue